import { Box, Typography, Stack } from '@mui/material';
import React from 'react';

import HowWeRankVendors from '@/components/vendor/HowWeRankVendors';

/**
 * Terr.ai Hero Section
 *
 * Property management focused messaging
 */
const TerraiHeroSection: React.FC = () => (
  <Stack spacing={2} alignItems="center" maxWidth="1000px">
    <Typography
      component="h1"
      sx={{
        fontSize: { xs: '1.75rem', md: '2.75rem' },
        fontWeight: 700,
        color: 'text.primary',
        textAlign: 'center',
      }}
    >
      Find the Right Provider for Your Home's Needs, Handled by AI - 💯 Free
    </Typography>

    {/* Description and How We Rank Vendors - Side by Side */}
    <Stack
      direction={{ xs: 'column', md: 'row' }}
      spacing={{ xs: 3, md: 6 }}
      alignItems={{ xs: 'center', md: 'flex-start' }}
      sx={{ width: '100%', maxWidth: '1200px' }}
    >
      <Box sx={{ flex: 1, textAlign: { xs: 'center', md: 'left' } }}>
        <Typography
          variant="body1"
          color="text.primary"
          fontWeight={400}
          fontSize="1rem"
          sx={{ mb: 2, px: 3 }}
        >
          From quick fixes like hanging a light or moving furniture to emergencies, plumbing
          repairs, and full renovations, your AI-powered home assistant makes it simple. Terri
          finds trusted providers, contacts them on your behalf, and collects quotes so you can
          compare and choose the right fit—saving you time, stress, and hassle.
        </Typography>
      </Box>
    </Stack>

    <Box sx={{ flex: 1, width: '100%', maxWidth: { xs: '100%', md: '500px' } }}>
      <HowWeRankVendors initialExpanded={false} />
    </Box>

    {/* Trust indicators */}
    <Box
      sx={{
        background: 'linear-gradient(135deg, #E3F2FD 0%, #F1F8E9 100%)',
        border: '1px solid #E8F5E8',
        borderRadius: 2,
        p: 2.5,
        mx: 3,
        mb: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
      }}
    >
      <Box sx={{ fontSize: '1.5rem' }}>🛡️</Box>
      <Box sx={{ textAlign: 'center' }}>
        <Typography
          variant="body1"
          sx={{ fontWeight: 700, color: 'primary.main', fontSize: '1rem', mb: 0.5 }}
        >
          100% Free • No Spam • Privacy Protected
        </Typography>
        <Typography
          variant="body2"
          sx={{ color: 'text.secondary', fontSize: '0.875rem', lineHeight: 1.4 }}
        >
          Give us the project basics, and we'll reach out to contractors for you. Your phone and
          email stay private, so you never deal with spam.
        </Typography>
      </Box>
    </Box>
  </Stack>
);

export default TerraiHeroSection;
